module.exports = __webpack_public_path__ + "insta.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/insta.png
// module id = 210
// module chunks = 0